export const MIN_SEARCH_STRING_LENGTH = 3;

export const TOPIC_TYPE = 'topic';
export const TICKET_TYPE = 'ticket';
export const COMMUNITY_FORUM_QUESTION_TYPE = 'community_forum_question';
